import apiClient from './apiClient'

/**
 * Get notifications data
 * @returns {INotifications}
 */
export const getNotifications = async () => await apiClient.get('/api/notifications/')
